var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-tile is-slider"},[_c('carousel',{attrs:{"perPage":1,"paginationPadding":0,"paginationColor":"#cccccc","paginationActiveColor":"black","speed":150}},_vm._l((_vm.slides),function(i){return _c('slide',{key:i},[_vm._t(i)],2)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }